import { MENU_STATE_KEY } from '@constants/local-storage.constant';
import { useEffect, useState } from 'react';
import { MainHook, MenuState } from '../interfaces/main.interfaces';

function useMain(): MainHook {
	// States
	const [menuState, setMenuState] = useState<MenuState>('big');

	// Functions
	function toggleMenu(): void {
		const newState = menuState === 'big' ? 'small' : 'big';
		setMenuState(newState);

		localStorage.setItem(MENU_STATE_KEY, newState);
	}

	// Effects
	useEffect(() => {
		const savedState = localStorage.getItem(MENU_STATE_KEY);
		setMenuState(savedState === 'small' ? 'small' : 'big');

		if (!savedState) {
			localStorage.setItem(MENU_STATE_KEY, 'big');
		}
	}, []);

	return {
		menuState,
		toggleMenu,
	};
}

export default useMain;
